<template>
  <div>
    <div class="columns">
      <div class="column">
          <!--uploaded document view and drop zone-->
          <div id="drop-zone" class="drop-zone">
            <div v-for="element in PlaceholdersData" :key="element.id">
              <!-- signature element-->
              <div v-if="element.type=='signature'" :id="element.id" >

                <div v-if="hideSignatureImage">
                  <b-button @click="showSignatureModal(element.id)" :disabled="reviewOnly">Signature</b-button>
                </div>
                <div v-else>
                  {{ updatePlaceholdervalue(element.type,element.id,DbimgURl) }}
                  <img  @click="showSignatureModal(element.id)" :src="$base_public_url+DbimgURl" alt="signature" style="width: 100px; height: 60px; border:1px solid black; border-radius: 10px; padding: 10px"  ref="img"  :id="element.id">
                </div>
              </div>

              <!--checkbox element-->
              <div v-if="element.type=='checkbox'" :id="element.id" >
                <b-checkbox v-model="element.value"  @input="resetInvalidStatus(element.id)" :disabled="reviewOnly">CheckBox</b-checkbox>
              </div>

              <!--text field element-->
              <div v-if="element.type=='text-box'" :id="element.id">
                <b-input v-model="element.value"  @input="resetInvalidStatus(element.id)" :disabled="reviewOnly"></b-input>
              </div>

              <!--datepicker element-->
              <div v-if="element.type=='date-picker'" :id="element.id">
                <b-input v-model="element.value" @click.native="showAddDateModal(element.id);resetInvalidStatus(element.id)" :disabled="reviewOnly"></b-input>
              </div>

            </div>

            <canvas :id="'the-canvas'+render" style="width: 100%; height: 100%;border: 1px solid black" v-for="render in TotPage" :key="render.id"></canvas>
          </div>
      </div>

      <!--comments-->

      <div class="column is-4" >
<!--        <add-comment  :coordinateData="PlaceholdersData"  :DbimgURl="DbimgURl" ></add-comment>-->
        <div class="box">
          <div class="card">
            <b-button type="is-info" @click="AddComment" icon-left="plus-thick" expanded>Add Comment</b-button>
            <hr style="border-top: 1px solid black;">
            <b-message v-for="err in ErrosMsgs" :key="err.id" type="is-danger" @clear-errors="clearErrors">
              {{err.type}} {{err.msg}}
            </b-message>
            <ul>
              <li v-for="comment in comments" :key="comment.id">
                <div class="box-comment mt-3">
                  <b-field
                      :id="comment.id"
                      :type="invalidComment == '' ? '' : 'is-danger'"
                      :message="invalidComment"
                      label="Comment" style="text-align: left">
                    <b-input maxlength="200" type="textarea" v-model="comment.value" @input="resetComment('invalidComment')"></b-input>
                  </b-field>
                  <b-button type="is-danger" outlined rounded size="is-small" @click="RemoveComment(comment.id)">Remove</b-button>
                </div>
              </li>
            </ul>


            <div class="mt-5">
              <div class="columns">
                <div class="column">
                  <b-button outlined rounded expanded type="is-danger" @click="showDeclineModal = true">Decline</b-button>
                </div>
                <div class="column">
                  <b-button outlined rounded expanded type="is-info" @click="validateAndSubmit" :loading="isSubmitting">Send</b-button>
                </div>
              </div>
            </div>

            <!--attachments--------------------------------------------------------------------->
             <hr style="border-top: 1px solid black;">
              <div class="columns" v-for="attachment in attachments" :key="attachment.id">
                <div class="attachment-card">
                  <div class="column">
                    <p>{{attachment.document_name }}</p>
                  </div>
                  <div class="column is-3">
                    <b-button type="is-dark"
                              icon-right="download" @click="downloadAttachment(attachment.id,attachment.document_name)" />
                  </div>
                </div>
              </div>
          </div>

          <!--show success modal-->
          <SendSuccessModal v-if="showSendSuccessModal" @closeDocumentSendModal="returnback"></SendSuccessModal>
        </div>
      </div>

    </div>
    <!--add signature modal-->
    <AddSignatureModal v-if="showAddSignatureModal" @closeModal="showAddSignatureModal = false" @on-signature-added="getSignature"></AddSignatureModal>

    <!--OTP Component-->
    <EnterOTPModal v-if="showOTPComp && false" @on-otp-valid="showCommentComp"></EnterOTPModal>

    <AddDateModal v-if="showDateModal" @close="closeDateModal" @on-date-added="getDateModalValue"></AddDateModal>

    <ConfirmDeclineModal v-if="showDeclineModal"  :showModal="showDeclineModal" :document_id="$route.params.document_id" @on-decline-close="closeDeclineModal"></ConfirmDeclineModal>

  </div>


</template>

<script>

import axios from "axios";
// import html2pdf from 'html2pdf.js'
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
// import AddComment from "@/components/frontend/AddComment";
import EnterOTPModal from "@/components/frontend/EnterOTPModal";
import AddDateModal from "@/components/frontend/AddDateModal";
import AddSignatureModal from "@/components/frontend/AddSignatureModal/AddSignatureModal";
import SendSuccessModal from "@/components/common/SendSuccessModal";
import ConfirmDeclineModal from "@/components/frontend/ConfirmDeclineModal";


export default {

  name:'document-view',

  props:['imageURL','dbImagepath'],

  components:{
    // ProgressBar,

    EnterOTPModal,
    AddDateModal,
    AddSignatureModal,
    SendSuccessModal,
    ConfirmDeclineModal

  },

  data() {

    return {

      PlaceholdersData:[],
      document_url:'',
      document_id:'',

      coordinateAdjustRatio:{
        x:1,
        y:1.035,
      },

      //pdf render
      TotPage:'',
      Pageindex:[],
      elementCount:'',
      showDeclineModal:false,

      // current document data --------------------------------------
      currentDocTotalPlaceholders : 0,
      currentDocCompletedPlaceholders : 0 , // should be default to 0

      showConfirm:false,
      showOTPComp:false,
      showAddComments:false,

      completePlaceholders:[],
      signatureCount:0,

      //date modal
      showDateModal:false,
      currentSelectedDateInputID:'',

      //show add signature modal
      showAddSignatureModal : false,
      DbimgURl:'',
      hideSignatureImage:true,

      comments:[],
      commentCount:0,
      invalidComment:'',
      showSendSuccessModal:'',
      formIsInvalid:false,
      isSubmitting:false,
      invitee_ip:'',

      regex:{
        message: /[a-zA-Z0-9]+\s?[a-zA-Z0-9]+$/,
      },

      ErrosMsgs:[],
      signatureElementID:'',
      reviewOnly:'',

      attachments:[]


    }
  },

  methods:{

    closeDeclineModal:function (){
      console.log('close modal declined');
      this.showDeclineModal = false
    },

    resetComment:function (key){
      this[key] = ''
      this.formIsInvalid = false
    },

    AddComment:function (){
      var comp = this
      if(comp.commentCount > 0){
        comp.$buefy.toast.open({
          message: 'Cannot add more than 1 comments',
          type: 'is-danger'
        })
      }else{
        comp.commentCount++
        comp.comments.push({id:comp.commentCount,value:''})
      }

    },

    RemoveComment:function (id) {
      var comp = this
      comp.commentCount--
      comp.comments.forEach((comment,index)=>{
        if(id == comment.id){
          comp.comments.splice(index,1)
        }
      })

    },

    validateComments:function (){
      var formIsValid = true

      if(this.comments.length > 0){
        this.comments.forEach((comment)=>{

          if(comment.value==''){
            this.invalidComment = 'Comment cannot be empty'
            formIsValid = false
          }else if(!this.regex.message.test(comment.value)){
            this.invalidComment = 'Comment cannot contain special characters or blanks'
            formIsValid = false
          }

        })

      }

      if(formIsValid){
        return true
      }
      else{
        return false
      }
    },

    downloadAttachment:function (attachmentID,filename){
      var comp = this

      axios({
        url: comp.$base_url+'/customer/downloadAttachment/'+attachmentID,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        console.log(response)
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },

    validateAndSubmit:function (){
      if(this.validateComments()){
        this.submitCooridnates()
      }
      else{
        this.formIsInvalid = true
      }
    },

    returnback(){
      this.$router.push({name:'completeView'})
    },

    submitCooridnates:function (){
      var comp = this
      var invalid = true
      var status
      comp.PlaceholdersData.forEach((coords)=>{
        if(coords.type == 'signature'){
          if(comp.DbimgURl == ''){
            // console.log('not sign')
            status = this.findDuplicates(coords.id,coords.type)
            if(status ==  false){
              invalid = false
            }
            invalid = false

          }
        }else if (coords.value == ''){
          status = this.findDuplicates(coords.id,coords.type)
          if(status ==  false){
            invalid = false
          }

        }
      })

      if(invalid){
        console.log(invalid+ 'invalid status----')
        this.SaveCoordinates()
      }else{
        console.log(invalid+ 'invalid status----')
      }

    },

    findDuplicates : function(id,type){

      if(this.ErrosMsgs.length <= 0){
        this.ErrosMsgs.push({id:id,type:type,msg:'field cannot be empty'})
        return false
      }else{

        var index = this.ErrosMsgs.findIndex(x => x.id == id);
        if(index === -1){
          this.ErrosMsgs.push({id:id,type:type,msg:'field cannot be empty'})
          return false
        }else{
          console.log('already exist')
          return false
        }

      }
    },



    SaveCoordinates:function(){
      var comp = this

      comp.isSubmitting = true
      axios.post(comp.$base_url+'/customer/savecoordinateswithvalue', {
        // invitee_token:comp.$root.invitee_token,
        // invitee_nic:comp.$root.customerData.nicNumber,
        coordinate:JSON.stringify(comp.PlaceholdersData),
        comments:JSON.stringify(comp.comments),
        signed_location:JSON.stringify(comp.$root.location_data),
        signed_ip:comp.$root.invitee_ip_address,
        client_number:comp.$route.params.client_number,
        link:comp.$customer_url
      })
          .then(function (response){
            var arr = [];
            arr = response.data

            console.log(response)
            if(arr.success == true) {
              comp.isSubmitting =false
              comp.showSendSuccessModal = true

            }else{
              comp.isSubmitting =false
              comp.$buefy.toast.open({
                message: arr.data.message,
                type: 'is-danger'
              })
            }



          })
          .catch(function (error) {
            console.log(error);
          });

    },


    clearErrors:function(){
      console.log('clear errors')
    },



    resetInvalidStatus: function(id){
      this.ErrosMsgs.forEach((err,index)=>{
        if(err.id == id){
          this.ErrosMsgs.splice(index,1)
        }
      })
    },

    showSignatureModal:function (id){
      var comp = this
      console.log(id+'show modal')
      comp.signatureElementID =id
      comp.showAddSignatureModal = true
    },

    getSignature(e){
      const comp = this
      comp.getLocation()
      comp.getInviteeIP()
      if(e.signature){
        // TODO :: assign returned signature to the placeholder
        console.log("Signature received ------------ ")
        console.log(e.signature)
        comp.showAddSignatureModal = false
        comp.resetInvalidStatus(comp.signatureElementID) // clear error msg
        console.log('signature data'+e.signature.verifiedSignatureData.signature_path)
        comp.DbimgURl = e.signature.verifiedSignatureData.signature_path
        comp.hideSignatureImage =false
      }
    },

    closeDateModal(){
      this.showDateModal =false
    },

    showAddDateModal:function (elementID){
      console.log('clicked')
      this.showDateModal =true
      this.currentSelectedDateInputID = elementID
    },

    getDateModalValue:function (e){
      var DateElement = document.getElementById(this.currentSelectedDateInputID)
      console.log(DateElement)

      this.PlaceholdersData.forEach((element)=>{
        if(element.id == this.currentSelectedDateInputID){
          element.value = e
        }
      })
      this.showDateModal = false
    },


    valuechange:function(){
      var comp = this
      console.log('value change')
      comp.updateCurrentDocCompletedPlaceholders()
      if(comp.currentDocCompletedPlaceholders == comp.currentDocTotalPlaceholders){
        comp.showConfirm = true
      }
    },

    updatePlaceholdervalue(type,id,imageurl){
      var comp = this
      console.log(type+''+id+''+imageurl)
      comp.PlaceholdersData.forEach((element)=>{
        if(element.type == type && element.id == id){
          element.value = imageurl
        }
      })
    },

    // updateCurrentDocCompletedPlaceholders(){
    //   const comp = this
    //
    //
    //   comp.PlaceholdersData.forEach((placeholder)=>{
    //     if(placeholder.value != ''){
    //
    //       //check complete placeholder array
    //       if(comp.completePlaceholders.length >0){
    //         console.log('complete array not empty')
    //         comp.completePlaceholders.forEach((complete,index)=>{
    //           if(complete.id == placeholder.id){
    //             comp.completePlaceholders.splice(index, 1);
    //             comp.completePlaceholders.push({id:placeholder.id,is_complete:true})
    //             comp.currentDocCompletedPlaceholders++
    //           }else{
    //             comp.completePlaceholders.push({id:placeholder.id,is_complete:true})
    //             comp.currentDocCompletedPlaceholders++
    //           }
    //         })
    //       }else{
    //         comp.completePlaceholders.push({id:placeholder.id,is_complete:true})
    //         comp.currentDocCompletedPlaceholders++
    //         console.log('complete array empty')
    //       }
    //
    //
    //     }else{
    //       //check element type
    //       if(placeholder.type == 'signature'){
    //         console.log('signatures')
    //         comp.signatureCount++
    //         comp.currentDocCompletedPlaceholders = comp.signatureCount
    //       }else{
    //         //check complete placeholder array
    //         if(comp.completePlaceholders.length >0){
    //           console.log('complete array not empty')
    //           comp.completePlaceholders.forEach((complete,indexcomplete)=>{
    //             if(complete.id == placeholder.id){
    //               comp.currentDocCompletedPlaceholders--
    //               comp.completePlaceholders.splice(indexcomplete, 1);
    //             }
    //           })
    //         }
    //       }
    //
    //     }
    //   })
    //   // if( comp.currentDocCompletedPlaceholders < comp.currentDocTotalPlaceholders){
    //   //   comp.currentDocCompletedPlaceholders++
    //   // }
    //   // else{
    //   //   comp.currentDocCompletedPlaceholders = 0
    //   // }
    //   //
    //   // if(comp.currentDocCompletedPlaceholders == comp.currentDocTotalPlaceholders){
    //   //   comp.showConfirm = true
    //   // }
    //   //
    //   // console.log("completed placeholders = "+ comp.currentDocCompletedPlaceholders)
    // },

    getInviteeCoordinates:function (){
      var component = this
      axios.post(component.$base_url+'/customer/getCoordinates',{
        client_number:component.$route.params.client_number,
        document_id : component.$route.params.document_id,
      })
          .then(function (response){
            var arr = []
            arr = response.data

            if(response.data.success == true){
              console.log(arr.data.inviteeData.coordinates)
              console.log(arr.data.inviteeData)
              component.PlaceholdersData =JSON.parse(arr.data.inviteeData.coordinates)
              var reviewVal = arr.data.inviteeData.review_only
              console.log(reviewVal);
              if(reviewVal == 1){
                component.reviewOnly = true
              }else{
                component.reviewOnly = false
              }
              setTimeout(() => {
                component.getInviteeDocument()
                component.AppendPlaceholdersToBody();
              }, 200)
            }else{
              //show alert
              component.$buefy.toast.open({
                message: arr.data.message,
                type: 'is-danger'
              })
            }

          }).catch(function (error) {
        console.log(error);
      });
    },

    //get uploaded document
    getInviteeDocument:function(){
      var component = this
      axios.post(component.$base_url+'/customer/getUploadedDocument',{
        document_id:component.$route.params.document_id,
        invitee_token : component.$root.invitee_token
      })
          .then(function (response){
            var arr = []
            arr = response.data

            if(response.data.success == true){
              component.document_url = arr.data.document_url
              // component.document_url = 'https://www.pdf995.com/samples/pdf.pdf'
              component.renderPDF()
            }else{
              //show alert
              component.$buefy.toast.open({
                message: arr.data.message,
                type: 'is-danger'
              })
            }

          }).catch(function (error) {
        console.log(error);
      });
    },

    //add placeholders to body
    AppendPlaceholdersToBody:function (){
      var component = this
      console.log('placeholders  :'+component.PlaceholdersData)
      component.PlaceholdersData.forEach((placeholder) => {

        console.log("Y before : "+placeholder.Ycord)

        placeholder.Xcord = (placeholder.Xcord)*component.coordinateAdjustRatio.x
        placeholder.Ycord = (placeholder.Ycord)*component.coordinateAdjustRatio.y

        console.log("Y after : "+placeholder.Ycord)

        console.log('element list  ' + placeholder.id )

        var elm = document.getElementById(placeholder.id);
        // var content = document.getElementById('pdfview-1')
        console.log(elm);

        elm.style.left = placeholder.Xcord+'px'
        elm.style.top = placeholder.Ycord+'px'
        elm.style.padding =10+'px'
        elm.style.position='absolute';
        elm.style.display='inline';

      })

    },

    getAttachmentsList:function (){

      var component = this
      axios.post(component.$base_url+'/customer/getAttachmentsList',{
        document_id:component.$route.params.document_id,
      })
          .then(function (response){
            var arr = []
            arr = response.data

            if(response.data.success == true){
              console.log('attachments list ---------------------')
              console.log(arr);
              component.attachments = arr.data
            }else{
              //show alert
              component.$buefy.toast.open({
                message: arr.data.message,
                type: 'is-danger'
              })
            }

          }).catch(function (error) {
        console.log(error);
      });
    },

    renderPDF:function () {
      var component = this
      var url = component.document_url;
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      // console.log('url -- '+component.$base_public_url+url);

      console.log('url -- '+url);
      var loadingTask = pdfjsLib.getDocument(component.$base_public_url+url);

      loadingTask.promise.then(function(pdf) {
        console.log('PDF loaded');

        // Fetch the first page

        var totalpages = pdf.numPages;
        component.TotPage = totalpages

        for(var x= 1; x <= totalpages; x++){
          component.Pageindex.push({pageIndex:x})
        }

        console.log('total pages'+totalpages)
        if(totalpages > 1) {
          console.log('more than one page')
          component.Pageindex.forEach((element)=>{
            pdf.getPage(element.pageIndex).then(function(page) {
              console.log('Page loaded');

              var scale = 1.5;
              var viewport = page.getViewport({scale: scale});

              // Prepare canvas using PDF page dimensions
              var canvas = document.getElementById('the-canvas'+element.pageIndex);

              var context = canvas.getContext('2d');
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Render PDF page into canvas context
              var renderContext = {
                canvasContext: context,
                viewport: viewport
              };
              var renderTask = page.render(renderContext);
              renderTask.promise.then(function () {
                console.log('Page rendered');
              });
            });
          })
        }else{
          var pagenumber = 1;
          pdf.getPage(pagenumber).then(function(page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({scale: scale});

            // Prepare canvas using PDF page dimensions
            var canvas = document.getElementById('the-canvas1');

            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              console.log('Page rendered');
            });
          });
        }


      }, function (reason) {
        // PDF loading error
        console.error(reason);
      });
    },

    //show comment comp
    showCommentComp(){
      this.showAddComments =true
      this.showOTPComp = false
    },

    //get invitee's location
    getLocation:function (){
      var comp = this
      navigator.geolocation.getCurrentPosition(function(pos){
        comp.$root.location_data = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy
        }

        console.log(pos.coords)
      })
    },

    //get invitee's ip address
    getInviteeIP:function (){
      fetch('https://api.ipify.org?format=json')
          .then(x => x.json())
          .then(({ ip }) => {
            this.$root.invitee_ip_address = ip;
          });
    },



  },

  mounted() {

    this.getInviteeCoordinates()
    this.getAttachmentsList()

  }

}
</script>

<style scoped>

.modal-card-title{
  font-weight: bold;
  background-color: #0D5DA3;
  font-size: 28px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.modal-card-body{
  border-radius: 0 0 5px 5px;
}

#mypdf{
  position: relative;
}

#drop-zone{
  position: relative;
  margin-left: 80px;
}

.box-comment{
  box-shadow: 0px 9px 17px rgba(0, 0, 0, 0.1);
  background: white;
  border-radius: 10px;
  padding: 10px;
}

.card{
  background-color: #F2F4FF;
  height: 100%;
  padding: 10px;
}

.attachment-card{
  margin: 10px;
  background-color: white;
  padding: 10px;
  display: flex;
  width: 100%;
}

</style>
